export const iconFontAwesomeDevicesHardwareTachographDigital = (
	<i className="fa-solid fa-tachograph-digital"></i>
);
